"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPayAtCourseExtras = void 0;
const getPayAtCourseExtras = (config) => {
    const hasPayAtCourseExtras = () => {
        if (config?.caddies?.enabled &&
            config?.caddies?.payment_option === "ON_ARRIVAL") {
            return true;
        }
        if (config?.carts?.enabled &&
            config?.carts?.payment_option === "ON_ARRIVAL") {
            return true;
        }
        return false;
    };
    const payAtCourseExtras = () => {
        if (!hasPayAtCourseExtras()) {
            return null;
        }
        const payAtCourse = [];
        const payAtCoursePrice = [];
        if (config?.caddies?.enabled &&
            config?.caddies?.payment_option === "ON_ARRIVAL") {
            payAtCoursePrice.push(config.caddies.total || 0);
            payAtCourse.push(`${config.caddies?.quantity} x ${config?.caddies?.type === "SINGLE_CADDIE"
                ? "single caddie"
                : "shared caddies"}`);
        }
        if (config?.carts?.enabled &&
            config?.carts?.payment_option === "ON_ARRIVAL") {
            config?.carts?.types &&
                config?.carts?.types.map((type) => {
                    if (type.quantity === 0)
                        return null;
                    payAtCoursePrice.push(type.total);
                    payAtCourse.push(`${type.quantity} x ${type.type === "SINGLE_CART" ? "single cart" : "shared cart"}`);
                });
        }
        const price = payAtCoursePrice.reduce((acc, cur) => acc + cur, 0);
        if (price === 0) {
            return null;
        }
        return {
            title: `${payAtCourse.join(" + ")} at ${config?.course?.name?.en}`,
            golfers: config?.where_when_who?.number_of_golfers,
            date: config?.where_when_who?.date,
            price: price,
        };
    };
    return payAtCourseExtras();
};
exports.getPayAtCourseExtras = getPayAtCourseExtras;
